<button class="pill icon-btn" type="button" *ngFor="let pill of pills">
    <span>{{ pill | uppercase }}</span>
    <span class="material-icons pointer" (click)="deletePill(pill)">close</span>
</button>